import { render, staticRenderFns } from "./ActiveTabHeader.vue?vue&type=template&id=2139fd28&"
import script from "./ActiveTabHeader.vue?vue&type=script&lang=js&"
export * from "./ActiveTabHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports